<template>
    <aside class="blog-sidebar">
        <search-box />
        
        <blog-categories 
            :title="dlabData.blogData.sidebar.categories.title" 
            :categories="dlabData.blogData.sidebar.categories.lists" />

        <trending-questions
            :title="dlabData.blogData.sidebar.trendingPosts.title"
            :lists="dlabData.blogData.sidebar.trendingPosts.posts"
            className="blog-sidebar-item"
         />

        <blog-tags 
            :title="dlabData.blogData.sidebar.tags.title"
            :lists="dlabData.blogData.sidebar.tags.items" />


        <follow-and-connect />
    </aside>
</template>

<script>
import dlabData from '@/store/store.js';
import BlogCategories from '../cards/BlogCategories.vue'
import SearchBox from '../cards/SearchBox.vue'
import TrendingQuestions from '../cards/TrendingQuestions.vue';
import BlogTags from '../cards/BlogTags.vue';
import FollowAndConnect from '../pieces/FollowAndConnect.vue';

export default {
    name: 'BlogSidebar',
    components: {
        SearchBox,
        BlogCategories,
        TrendingQuestions,
        BlogTags,
        FollowAndConnect,
    },
    data() {
        return {
            dlabData
        }
    }
    
}
</script>